import common from './common'
import { REPORT_PARAMS, SDK_PRODUCT } from '@/config/dataMap'
const vip_version = REPORT_PARAMS.vip_version
const report_version = REPORT_PARAMS.report_version
const show_from = REPORT_PARAMS.show_from

const unpaidOperateKfmt = 'duba_uppaid_tips:9041 tipsshow:byte tipsclick:byte ver:string noshowreason:string'

export default {
  REPORT: {
    // 未支付完成引导上报
    reportUnpaidOperate (params) {
      const info = {
        tipsshow: 0,
        tipsclick: 0,
        ver: report_version,
        noshowreason: '',
      }
      return common.REPORT.client_report_by_kfmt(unpaidOperateKfmt, common.API.replaceObj(info, params))
    }
  }
}
